<div class="patient-task-info !items-center w-full !p-0 h-full">
  <div
    (click)="onClickOnElement(getPatientNameAndDob())"
    class="flex w-full flex-row items-center justify-between"
  >
    <mat-list *ngIf="latestTasks?.data; else noDataBlock" class="patient-task">
      <div class="patient-task-name table-text">
        {{ latestTasks?.data?.task_name }}
      </div>
      <div
        [ngClass]="{ 'color-danger': latestTasks?.data?.priority === 'veryHigh' }"
        class="table-date patient-task-date"
      >
        {{ latestTasks?.data?.contractor?.name }}
        {{ latestTasks?.data?.contractor?.surname }};
        {{ latestTasks?.data?.goalDateOn | date: ('GENERAL.date_time_format' | translate) }}
      </div>
    </mat-list>

    <ng-template #noDataBlock>
      <!-- <div class="patient-visit-info h-full !items-center text-xs">Keine Aufgaben</div> -->
      <div class="patient-visit-info h-full !items-center text-xs">-</div>
    </ng-template>

    <!-- <div class="patient-task-button">
      <button *ngIf="patient && latestTasks" (click)="onClickOnAddTask($event)" mat-icon-button>
        <mat-icon>add</mat-icon>
      </button>
    </div> -->
  </div>

  <!-- Clip toggle button outside the loop -->
  <div class="patient-task-button">
    <button (click)="toggleClip(); $event.stopPropagation()" *ngIf="showButton" mat-icon-button>
      <mat-icon>{{ isClipped ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</mat-icon>
    </button>
  </div>
</div>
